import React from 'react'
import Table from '../../../../common/components/table'


export default function LayoutCardComponent ({handleDelete,setPageData,paginationData,additionButtons,rowData,columnDefs,onEdit}: any) {
  return (
    <>
<Table
    columnData={columnDefs}
    rowData={rowData}
    onEdit={onEdit}
    additionButtons={additionButtons}
    headingName="Cards"
    paginationData={paginationData}
    setPageData={setPageData}
    onDelete={handleDelete}
    />   
        </>
  )
}